<template>
  <div class="card">
    <b-table :items="items" :fields="fields" bordered responsive striped hover>
      <template #cell(link)="data">
        <a :href="data.item.link" target="_blank">
          <b-icon icon="link"></b-icon>
        </a>
      </template>
      <template #cell(economy)="data">
        <span :class="getEconomyClass(data.item.economy)">
          {{ data.item.economy }}
        </span>
      </template>
      <template #cell(average)="data">
        <span :class="getAverageClass(data.item.average, data.item.goal)">
          {{ data.item.average }}
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "MediaPlacaTable",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        { key: "link", label: "Link" },
        { key: "id", label: "ID" },
        { key: "date", label: "Data" },
        {
          key: "currentKm",
          label: "Horimetro Atual",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "kmDriven",
          label: "Hora Trabalhadas",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "liters",
          label: "Litros",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "price",
          label: "Preço",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "totalValue",
          label: "Valor Total",
          thClass: "td-number",
          tdClass: "td-number",
        },
        { key: "fuelType", label: "Tipo de Combustível" },
        {
          key: "goal",
          label: "Meta",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "average",
          label: "Média",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "economy",
          label: "Economia",
          thClass: "td-number",
          tdClass: "td-number",
        },
        { key: "licensePlate", label: "Equipamento" },
        { key: "driver", label: "Motorista" },
      ],
    };
  },
  methods: {
    getEconomyClass(economy) {
      const numericValue = parseFloat(economy.replace(/[^\d.-]/g, ""));
      if (numericValue < 0) {
        return "danger";
      } else if (numericValue > 0) {
        return "success";
      } else {
        return "";
      }
    },
    getAverageClass(average, goal) {
      const numericValue = parseFloat(average.replace(/[^\d.-]/g, ""));
      const numericValue2 = parseFloat(goal.replace(/[^\d.-]/g, ""));
      if (numericValue > numericValue2 && numericValue != "0,00") {
        return "danger";
      } else if (numericValue < numericValue2) {
        return "success";
      }
    },
  },
};
</script>

<style scoped>
.card {
  width: 100%;
  max-width: 100%;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.212);
  border-radius: 14px;
  margin: 5px;
  transition: transform 0.3s, box-shadow 0.3s;
  overflow: hidden;
  align-items: center;
  border-color: #ffffff;
  border: 1px solid;
}

.danger {
  color: #ec5353;
  font-weight: 600;
}

.success {
  font-weight: 600;
  color: #34a019;
}
</style>
